<template>
  <div class="va-card" :style="computedCardStyle" v-bind:class="enableVerticalJustify">
    <div v-if="stripe" class="va-card__stripe" :style="computedStripeStyle"></div>

    <div v-if="image" class="va-card__image">
      <img :src="image" :alt="imageAlt">
      <div class="va-card__image-overlay" v-if="overlay"></div>
    </div>

    <div v-if="showSubImage" class="va-card__image" style="padding: 0%;">
      <sub-imagens ref="imagens" id="img" :sub="subImage"/>
      <div class="va-card__image-overlay"></div>
    </div>

    <div v-if="showHeader" class="va-card__header" :class="{'va-card__header--titleOnImage': titleOnImage}" >
      <div class="va-card__header-inner">
        <slot name="header">
          <div class="va-card__header-title" :style="{color: titleOnImage ? 'white !important' : $themes.info}">
            {{ title }}
          </div>

          <vuestic-tooltip v-if="tooltipOptions" :options="tooltipOptions" class="pull-right">
            <i class="fa fa-question-circle-o fa-lg toolTipHelp"></i>
          </vuestic-tooltip>

          <div class="va-card__header-actions">
            <slot name="actions" />
          </div>
        </slot>
      </div>
    </div>

    <div v-if="$slots.default" v-bind:class="[ enableTooltipOverflowX ? 'overflowEnabled' : 'overflowDisabled', 
    noPadding ? 'va-card__body--no-padding' : 'va-card__body']">
      <slot />
    </div>
    
    <div v-show="showFooter" class="va-card__footer" :class="{'va-card__footer--over': image && titleOnImage}">
      <slot name="footer">
        <va-list-separator/>
        <div class="va-card__footer-title" :style="{color: ! computedImageOrColor || 'white !important'}">
          {{ footerText }}
        </div>
        <div v-if="footerComplementar" class="va-card__footer-title" :style="{color: ! computedImageOrColor || 'white !important' }">
          {{ footerComplementar }}
        </div>
        <vuestic-tooltip v-if="footertooltipOptions" :options="footertooltipOptions" class="pull-right">
          <i class="fa fa-question-circle-o fa-lg toolTipHelp"></i>
        </vuestic-tooltip>
        <div class="va-card__header-actions">
          <slot name="footerActions" />
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
//import VaCard from 'vuestic-ui/src/components/vuestic-components/va-card/VaCard'
import SubImagens from '@/components/dashboard/raiox/SubImagens'
import { getGradientBackground } from '../../../services/color-functions'
import VuesticTooltip from '@/vuestic-theme/vuestic-components/vuestic-tooltip/VuesticTooltip'

export default {
  name: 'Sp360Panel',
  //mixins: [VaCard],
  components: { SubImagens, VuesticTooltip },
  props: {
    showSubImage: { type: Boolean, default: false },
    subImage: { type: Number, default: 0 },
    footerText: { type: String, default: null },
    footerComplementar: { type: String, default: null },
    footertooltipOptions: { type: Object, default: null },
    enableTooltipOverflowX: { type: Boolean, default: false },
    justifyVertically: { type: Boolean, default: false },
    tooltipOptions: { type: Object, default: null },
    stripe: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    noPaddingV: {
      type: Boolean,
      default: false,
    },
    noPaddingH: {
      type: Boolean,
      default: false,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    image: {
      type: String,
      default: '',
    },
    overlay: {
      type: Boolean,
      default: false,
    },
    imageAlt: {
      type: String,
      default: '',
    },
    titleOnImage: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: '',
    },
    tooltipOptions:{
      type: Object,
      default: () => {},
    },
  },
  data () {
    return {
      check: false,
    }
  },
  computed: {
    showFooter () {
      return !!this.footerText
    },
    selectPaddingStyle() {
      if(this.noPadding) 
        return 'va-card__body--no-padding'
      return 'va-card__body'
    },
    enableOverflowTooltip () {
      return this.enableTooltipOverflowX ? 'overflowEnabled' : 'overflowDisabled'
    },
    enableVerticalJustify () {
      return this.justifyVertically ? 'justifyVertically' : ''
    },
    showHeader () {
      return this.title || this.$slots.header || this.$slots.actions
    },
    computedCardBodyClass () {
      return {
        'va-card__body--no-padding-v': this.noPaddingV,
        'va-card__body--no-padding-h': this.noPaddingH,
        'va-card__body--no-padding': this.noPadding,
        'va-card__body--padding-top':
          (!this.showHeader && !this.noPaddingV && !this.noPadding) ||
          this.titleOnImage,
      }
    },
    computedStripeStyle () {
      return {
        background: this.$themes && this.$themes[this.stripe] ? this.$themes[this.stripe] : this.stripe,
      }
    },
    computedCardStyle () {
      if (this.color) {
        return {
          color: '#fff',
          background: getGradientBackground(this.$themes[this.color]),
        }
      }
    },
    computedImageOrColor(){
      let a = false
      let b = false
      if(this.color){
        a = true
      }
      if (this.titleOnImage) {
        b = true
      }
      return (a || b)
    }
  },

}
</script>

<style lang="scss">
//@import "vuestic-ui/src/components/vuestic-sass/resources/resources";
$font-cabecalho : 1.35rem;

.va-card {
  border-radius: $card-border-radius;
  border: none;
  box-sizing: border-box;
  box-shadow: $card-box-shadow;
  word-wrap: break-word;
  background-color: $white;
  position: relative;
  overflow: hidden;

  &__header {
    &-inner {
      display: flex;
      padding: 0.5rem $card-padding;
      min-height: 3.5rem;
      align-items: center;
    }

    &-title {
      font-weight: 300;
      font-size: $font-cabecalho !important;
      letter-spacing: $card-title-letter-spacing;
      text-transform: none;
      color: $vue-darkest-blue !important;
      font-family: Source Sans Pro Semibold, sans-serif;
    }

    &-actions {
      margin-left: auto;
      flex: 0 0 auto;
    }

    &--over {
      position: absolute;
      padding-top: 56%;
      width: 100%;
      top: 0;
      left: 0;

      &:last-child {
        height: 100%;
      }

      & > div {
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
      }
    }
    &--titleOnImage{
      position: absolute;
      margin-top: -5%
    }
  }

  &__body {
    padding: 0 $card-padding $card-padding;
    flex: 1 1 auto;

    &--no-padding-v {
      padding: 0 $card-padding;
    }

    &--no-padding-h {
      padding: $card-padding 0;
    }

    &--no-padding {
      padding: 0;
    }

    &--padding-top {
      padding-top: $card-padding;
    }
  }

  // CSS para os Rodapé de Disclaimers e legendas OBS: Precisa de um carinho!
  &__footer {
    &-color {
      font-weight: 100;
      font-size: 0.9rem;
      letter-spacing: $card-title-letter-spacing;
      text-transform: none;
      //color: #fff ;
      padding-left: 0.8rem;
      padding-bottom: 0.4rem;
    }

    &-inner {
      display: flex;
      padding: 0.5rem $card-padding;
      min-height: 3.5rem;
      align-items: center;
    }

    &-title {
      font-weight: 100;
      font-size: 0.9rem;
      letter-spacing: $card-title-letter-spacing;
      text-transform: none;
      color: $cinza-claro !important;
      padding-left: 0.8rem;
      padding-bottom: 0.4rem;
    }

    &-actions {
      margin-left: auto;
      flex: 0 0 auto;
    }

    > div > .va-list-separator--offset {
      margin-left: 0;
    }

  }

  &__image {
     padding-bottom: 20%;
     position: relative;
     height: auto;
     max-height: 100%;

    img {
      position: absolute;
      height: 100%;
      width: 100%;
      display: block;
      object-fit: cover;
    }

    &-overlay {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background-color: rgba(0, 0, 0, .3);
      pointer-events: none;
    }
  }

  &__stripe {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 0.5rem;
    z-index: 1;
  }

  .overflowEnabled {
    overflow-x: auto;
  }
  .overflowDisabled {
    overflow-x: visible;
  }

}

.justifyVertically {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

</style>
